import { type ReactNode } from 'react';
import type { Tier } from '../hooks/use-pricing-table';
import { PricingTierRow } from './pricing-tier-row';

type Props = {
  tiers: Tier[];
  ids: string[];
  errors: Set<number>;
  priceErrors: Set<number>;
  onUpdate: (i: number, t: Tier) => void;
  onRemove: (i: number) => void;
};

function rowProps(
  p: Props,
  i: number
): {
  id: string;
  tier: Tier;
  isFirst: boolean;
  isLast: boolean;
  canRemove: boolean;
  hasError: boolean;
  priceError: boolean;
} {
  const last = p.tiers.length - 1;
  return {
    id: p.ids[i] ?? `tier-${i}`,
    tier: p.tiers[i]!,
    isFirst: i === 0,
    isLast: i === last,
    canRemove: p.tiers.length > 1 && i > 0 && i < last,
    hasError: p.errors.has(i),
    priceError: p.priceErrors.has(i),
  };
}

export function PricingTierRows(p: Props): ReactNode {
  return (
    <div className="space-y-0.5">
      {p.tiers.map((_, i) => (
        <PricingTierRow
          key={p.ids[i]}
          {...rowProps(p, i)}
          onChange={(updated) => p.onUpdate(i, updated)}
          onRemove={() => p.onRemove(i)}
        />
      ))}
    </div>
  );
}
